import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-java-script',
    templateUrl: './java-script.component.html',
    styleUrls: ['./java-script.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('java-script')
export class JavaScriptComponent {
    formGroup = input<FormGroup>();
    model = input<any>();

    public defaultScript: string = 'source => {\n    const result = {}; // or []\n    // ... your mapping code here\n    return result;\n}';
    metaScript: any = { id: 'script', name: 'JavaScript', rows: 48, textStyle: '{"font-family":"monospace"}' };
}
